<template>
    <div class="form_group form_group_party">
        <display-message :option="message_option"></display-message>

<!--        <div v-html="party_name+' ('+_uid+')'" v-show="1"></div>-->
        <div class="form_row" v-show="option.stored_party&&available_stored_parties.length">
            <div class="select_container">
                <select :id="party_name+'_stored_party'" @change="fill_form_from_stored($event)">
                    <option value="0">-- Fill from Stored Contact --</option>
                    <option :value="stored_party_item.id" v-for="stored_party_item in available_stored_parties">{{ stored_party_item.formatted_name }}</option>
                </select>
            </div>
        </div>

        <div class="form_row" v-show="available_cached_parties.length">
            <div class="select_container">
                <select :id="party_name+'_cached_party'" @change="fill_form_from_cached($event)">
                    <option value="0">-- Previously used details --</option>
                    <option :value="cached_party_item.id" v-for="cached_party_item in available_cached_parties">{{ cached_party_item.formatted_name }}</option>
                </select>
            </div>
        </div>

        <div class="form_row" v-show="available_types.length > 1">
            <label :for="party_name+'_type'" v-html="cache_data_label.type" v-show="cache_data.type"></label>
            <div class="form_static_value" v-show="current_party.id" v-html="cache_data.type"></div>
            <div class="select_container" v-show="!current_party.id">
                <select :id="party_name+'_type'" :placeholder="cache_data_label.type" v-model="cache_data.type">
                    <option value="" disabled v-show="!cache_data.type">-- {{ cache_data_label.type }} --</option>
                    <option :value="available_type" v-for="available_type in available_types">{{ available_type }}</option>
                </select>
            </div>
        </div>

        <div v-if="cache_data.type == 'Individual'">
            <div class="form_row">
                <label :for="party_name+'_title'" v-html="cache_data_label.title" v-show="cache_data.title"></label>
                <div class="select_container">
                    <select :id="party_name+'_title'" :placeholder="cache_data_label.title" v-model="cache_data.title">
                        <option value="" disabled v-show="!cache_data.title">-- {{ cache_data_label.title }} --</option>
                        <option :value="available_title" v-for="available_title in available_titles">{{ available_title }}</option>
                    </select>
                </div>
            </div>
            <div class="form_row">
                <label :for="party_name+'_first_name'" v-html="cache_data_label.first_name" v-show="cache_data.first_name"></label>
                <input type="text" :id="party_name+'_first_name'" :placeholder="cache_data_label.first_name" v-model="cache_data.first_name">
            </div>
            <div class="form_row">
                <label :for="party_name+'_middle_name'" v-html="cache_data_label.middle_name" v-show="cache_data.middle_name"></label>
                <input type="text" :id="party_name+'_middle_name'" :placeholder="cache_data_label.middle_name" v-model="cache_data.middle_name">
            </div>
            <div class="form_row">
                <label :for="party_name+'_last_name'" v-html="cache_data_label.last_name" v-show="cache_data.last_name"></label>
                <input type="text" :id="party_name+'_last_name'" :placeholder="cache_data_label.last_name" v-model="cache_data.last_name">
            </div>
            <div class="form_row form_row_date_container" v-if="party_class === 'member' || party_class === 'additional_trustee'">
                <label for="trust_birthday" v-html="cache_data_label.birthday"></label>
                <input type="date" id="trust_birthday" :placeholder="cache_data_label.birthday" v-model="cache_data.birthday">
            </div>
        </div>
        <div v-else-if="cache_data.type == 'Company'">
            <!-- contactType is 'Company'/'Other Entity'-->
            <p style="font-size: 0.8em;padding: 0 1.5em 1em;margin: 0;">Please ensure you enter the full name of the company. E.g. " XYZ Pty Ltd"</p>
            <div class="form_row">
                <label :for="party_name+'_name'" v-html="cache_data_label.name" v-show="cache_data.name"></label>
                <input type="text" :id="party_name+'_name'" :placeholder="cache_data_label.name" v-model="cache_data.name">
            </div>
            <div class="form_row">
                <label :for="party_name+'_company_number'" v-html="cache_data_label.company_number" v-show="cache_data.company_number"></label>
                <input type="text" :id="party_name+'_company_number'" :placeholder="cache_data_label.company_number" v-model="cache_data.company_number">
            </div>
            <p style="font-size: 0.8em;padding: 0 1.5em 1em;margin: 0;">And / Or</p>
            <div class="form_row">
                <label :for="party_name+'_business_number'" v-html="cache_data_label.business_number" v-show="cache_data.business_number"></label>
                <input type="text" :id="party_name+'_business_number'" :placeholder="cache_data_label.business_number" v-model="cache_data.business_number">
            </div>
            <p style="font-size: 0.8em;padding: 0 1.5em 1em;margin: 0;" v-show="party_class != 'company_trustee'">Director name(s) for signature. If there are multiple directors, separate names by comma. e.g. "John Smith, Jane Doe"</p>
            <div class="form_row" v-show="party_class != 'company_trustee'">
                <label :for="party_name+'_director_name'" v-html="cache_data_label.director_name" v-show="cache_data.director_name"></label>
                <input type="text" :id="party_name+'_director_name'" :placeholder="cache_data_label.director_name" v-model="cache_data.director_name">
            </div>
        </div>
        <div v-else-if="cache_data.type == 'Trust'">
            <p style="font-size: 0.8em;padding: 0 1.5em 1em;margin: 0;">Please ensure you enter the full name of the trust. E.g. "The XYZ Trust"</p>
            <div class="form_row">
                <label :for="party_name+'_name'" v-html="cache_data_label.name" v-show="cache_data.name"></label>
                <input type="text" :id="party_name+'_name'" :placeholder="cache_data_label.name" v-model="cache_data.name">
            </div>
            <div class="form_group form_group_party_list">
                <div class="form_row">
                    <label>{{ cache_data_label['trustee'] }}</label>
                </div>
                <div class="form_row form_row_controller_container">
                    <input type="button" class="btn btn-primary" value="Add New" @click="current_trustee = 'new'" style="font-size: 0.6em;" v-show="!current_trustee">
                </div>
                <div class="form_row form_row_list_container">
                    <div class="form_row_list" v-show="!current_trustee" v-for="trust_party_id in cache_data['trustee']">
                        <div>
                            <span class="form_row_list_name">{{ form_root.item_map[form_root.module_name + '_party'][trust_party_id].formatted_name }}</span>
                            <a class="form_row_list_controller" href="javascript:void(0);" @click="current_trustee = trust_party_id"><span class="glyphicon glyphicon-pencil"></span></a>
                            <a class="form_row_list_controller" href="javascript:void(0);" @click="remove_sub_item(trust_party_id)"><span class="glyphicon glyphicon-trash"></span></a>
                        </div>
                    </div>
                </div>
                <update-party v-show="current_trustee" :current_id="current_trustee" @submit="update_trustee" :option="{item_list:form_root.item_list,item_map:form_root.item_map,party_name:party_class+'_trustee',party_class:party_class+'_trustee',form_root:form_root,stored_party:form_root.available_stored_parties}"></update-party>
            </div>
        </div>

        <div class="form_row" v-if="cache_data.type !== 'Trust'">
            <label :for="party_name+'_address'" v-html="cache_data_label.address_id" v-show="cache_data.address_id"></label>
            <p class="highlight_text" style="font-style: italic;font-size: 0.75em;" v-show="party_class == 'contact'">For PO Boxes, fill details in "Street Name". Leave "Care Of" and "Street Number" blank</p>
            <div class="select_container" v-show="cache_data.address_id !== 'Add New'">
                <select :id="party_name+'_address'" v-model="cache_data.address_id" :placeholder="cache_data_label.address_id">
                    <option value="" disabled v-show="!cache_data.address_id">-- {{ cache_data_label.address_id }} --</option>
                    <option value="0" v-show="party_class === 'stored_party'">Empty Address</option>
                    <option :value="cached_address.id" v-for="cached_address in form_root.item_list.address">{{ cached_address.full_address }}</option>
                    <option value="Add New">Add New</option>
                </select>
            </div>
        </div>
        <update-address :option="{item_list:form_root.item_list,item_map:form_root.item_map,address_name:party_name+'_address'}" v-model:new_address="cache_data.address_id" v-show="cache_data.address_id == 'Add New'"></update-address>

        <!-- TODO: Input for specific classes -->

        <div class="form_row" v-show="party_class == 'unit_holder' || party_class == 'special_unit_holder'">
            <label :for="party_name+'_unit_count'" v-html="cache_data_label.unit_count" v-show="cache_data.unit_count"></label>
            <input type="text" :id="party_name+'_unit_count'" :placeholder="cache_data_label.unit_count" v-model="cache_data.unit_count" @change="cache_data.unit_count = $root.fix_format(cache_data.unit_count,[{type:'integer'}])">
        </div>
        <div class="form_row" v-show="party_class == 'special_unit_holder' && !option.trust.ng">
            <label :for="party_name+'_income_type'" v-html="cache_data_label.income_type" v-show="cache_data.income_type"></label>
            <div class="select_container">
                <select :id="party_name+'_income_type'" :placeholder="cache_data_label.income_type" v-model="cache_data.income_type">
                    <option value="" v-show="!cache_data.income_type">-- {{ cache_data_label.income_type }} --</option>
                    <option :value="available_income_type" v-for="available_income_type in available_income_types">{{ available_income_type }}</option>
                </select>
            </div>
        </div>
        <div class="form_row" v-show="party_class == 'special_unit_holder' && !option.trust.ng">
            <label :for="party_name+'_redemption_type'" v-html="cache_data_label.redemption_type" v-show="cache_data.redemption_type"></label>
            <div class="select_container">
                <select :id="party_name+'_redemption_type'" :placeholder="cache_data_label.redemption_type" v-model="cache_data.redemption_type">
                    <option value="" v-show="!cache_data.redemption_type">-- {{ cache_data_label.redemption_type }} --</option>
                    <option :value="available_redemption_type" v-for="available_redemption_type in available_redemption_types">{{ available_redemption_type }}</option>
                </select>
            </div>
        </div>
        <div class="form_row" v-show="party_class == 'special_unit_holder' && !option.trust.ng && cache_data.redemption_type.indexOf('Percentage')>-1">
            <label :for="party_name+'_redemption_percentage'" v-html="cache_data_label.redemption_percentage"></label>
            <input type="number" min="0" max="100" step="5" style="width: auto" :id="party_name+'_redemption_percentage'" name="redemption_percentage" v-model="cache_data.redemption_percentage" :placeholder="cache_data_label.redemption_percentage">
            <label :for="party_name+'_redemption_percentage'">%</label>
        </div>
<!--        <div class="form_row" v-show="party_class == 'excluded_class'">-->
<!--            <label :for="party_name+'_description'" v-html="cache_data_label.description" v-show="cache_data.description"></label>-->
<!--            <textarea :id="party_name+'_description'" :placeholder="cache_data_label.description" v-model="cache_data.description"></textarea>-->
<!--        </div>-->

        <div v-if="party_class == 'contact'">
            <div class="form_row">
                <label :for="party_name+'_name'" v-show="cache_data.name">Company Name</label>
                <input type="text" :id="party_name+'_name'" placeholder="Company Name" v-model="cache_data.name">
            </div>
            <div class="form_row">
                <label :for="party_name+'_email'" v-html="cache_data_label.email" v-show="cache_data.email"></label>
                <input type="text" :id="party_name+'_email'" :placeholder="cache_data_label.email" v-model="cache_data.email">
            </div>
            <div class="form_row">
                <label :for="party_name+'_phone'" v-html="cache_data_label.phone" v-show="cache_data.phone"></label>
                <input type="text" :id="party_name+'_phone'" :placeholder="cache_data_label.phone" v-model="cache_data.phone">
            </div>
            <!--            <div class="form_row">-->
            <!--                <label :for="party_name+'_fax'" v-html="cache_data_label.fax" v-show="cache_data.fax"></label>-->
            <!--                <input type="text" :id="party_name+'_fax'" :placeholder="cache_data_label.fax" v-model="cache_data.fax">-->
            <!--            </div>-->
            <div class="form_row form_row_checkbox_container">
                <label :for="party_name+'_update_address'" v-html="cache_data_label.update_address"></label>
                <input type="checkbox" :id="party_name+'_update_address'" name="update_address" v-model="cache_data.update_address">
            </div>
        </div>

        <div class="form_row form_row_checkbox_container" v-show="cache_data.type !== 'Trust' && party_class !== 'stored_party' && party_class !== 'contact'">
            <label :for="party_name+'_store_for_future'" v-html="cache_data_label.store_for_future"></label>
            <input type="checkbox" :id="party_name+'_store_for_future'" name="store_for_future" v-model="cache_data.store_for_future">
        </div>

        <!-- Todo: Add Field for director_name, multiple Input fields, free text -->

        <div class="form_row form_row_controller_container" v-show="cache_data.address_id != 'Add New'">
            <input type="button" class="btn btn-primary" value="Save" @click="save()">
            <input type="button" class="btn btn-secondary-inverse" value="Cancel" @click="cancel()">
        </div>
    </div>    
</template>

<script>
    export default {
        name: "UpdateParty",
        props: ['option','current_id'],
        data() {
            let data_set = {
                autocomplete: null,
                available_titles: ['Mr','Miss','Mrs','Ms','Mstr','Dr'],
                available_income_types: ['Attributable Income','All the Net Income'],
                available_redemption_types: ['Return of Capital','Return of Capital + CPI','Return of Capital + Percentage','Return of Capital + Annual Percentage','Market Value'],
                cache_data_label: {
                    // class: 'Class',             // Define which type of trust party, some may have different hidden fields. e.g. trustee, settlor, unit_holders
                    type: 'Type',               // Individual or Company, individual defined by title, first_name, middle_name and last_name; company defined by name, acn and abn
                    address_id: 'Address',      //
                    trust_id: 'Trust',          // None modifiable field, refer to parent Trust Name

                    // Fields below for type = 'Individual'
                    title: 'Title',
                    first_name: 'First Name',
                    middle_name: 'Middle Name',
                    last_name: 'Last Name',
                    birthday: 'Date of Birth',

                    // Fields below for type = 'Company'
                    name:'Name',
                    company_number:'A.C.N.',
                    business_number:'A.B.N.',

                    // Fields below for type = 'Trust'
                    trustee:'Trustees',

                    // Fields below for special classes
                    email:'Email',                  // Only available for contact, is required if request electronic version of Trust
                    phone:'Phone',                  // Only available for contact
                    fax:'Fax',                      // Only available for contact
                    director_name:'Director Name',    // Only available for trustee that has type as Company, separate multiple names by comma, for sign purpose
                    description:'Description',      // Only available for exclude_class
                    unit_count:'Unit Count',        // Available for unit_holder and special_unit_holder
                    income_type:'Income Type',
                    redemption_type:'Redemption Type',  // Only available for special_unit_holder and is not available when Trust type is HDT
                    redemption_percentage:'Percentage',

                    update_address: 'Save delivery address',
                    store_for_future: 'Store for Future',
                },
                deleted_trustee: [],
                current_trustee: '',
                form_root: '',
                message_option: {
                    message: '',
                    message_type: ''
                },
            };
            let current_object = this;
            if (current_object.$parent) {
                let parent_object = current_object.$parent;
                data_set.form_root = parent_object;
                while (data_set.form_root.form_root && data_set.form_root !== data_set.form_root.form_root) {
                    data_set.form_root = data_set.form_root.form_root;
                }
                ['module_name','item_map','item_list'].forEach(function (field_name) {
                    if (parent_object[field_name]) {
                        data_set[field_name] = parent_object[field_name];
                    }
                });
            }
console.log('allen debug UpdateParty current_object',current_object,current_object.option.party_name,current_object._uid);
            data_set.cache_data = current_object.reset_cache_data({init:true,data_set:data_set});
            Object.keys(current_object.option).forEach(function (option_key) {
                data_set[option_key] = current_object.option[option_key];
            });
            return data_set;
        },
        computed: {
            available_stored_parties: function () {
                let current_object = this;
                let result = [];
                if (current_object.option.stored_party) {
                    let available_types = current_object.available_types;
                    current_object.option.stored_party.forEach(function (stored_party_item) {
                        if (available_types.indexOf(stored_party_item.type) !== -1) {
                            result.push(stored_party_item);
                        }
                    });
                }
                return result;
            },
            available_cached_parties: function () {
                let current_object = this;
                let result = {};

                if (current_object.form_root.item_list[current_object.form_root.module_name + '_party']) {
                    let available_types = current_object.available_types;
                    current_object.form_root.item_list[current_object.form_root.module_name + '_party'].forEach(function (party_item) {
                        if (available_types.indexOf(party_item.type) !== -1) {
                            result[party_item.formatted_name] = party_item;
                        }
                    });
                }
                return Object.values(result);
            },
            available_types: function () {
                let current_object = this;
                let result = ['Individual'];

                // -- Except party_class listed below, trust_party can have type Individual or Company

                // 25 Mar, 2024, Michael called Chris to confirm that appointor can be a Company
                if (['contact','beneficiary','beneficiary_a','beneficiary_b','beneficiary_cv','beneficiary_grandparent','beneficiary_parent','beneficiary_child','member','additional_trustee','voter','borrower'].indexOf(current_object.option.party_class) === -1) {
                // if (['contact','appointor','beneficiary','beneficiary_a','beneficiary_b','beneficiary_cv','member','additional_trustee'].indexOf(current_object.option.party_class) === -1) {
                // 28 Mar, 2023 change to only Principal Beneficiary has to be Individual
                // if (['contact','beneficiary'].indexOf(current_object.option.party_class) === -1) {
                    result.push('Company');
                }

                // For party_class listed below, trust_party type is Company only
                if (['company_trustee'].indexOf(current_object.option.party_class) !== -1) {
                    result = ['Company'];
                }


                // For party_class listed below, trust_party can also choose the type Trust
                if (['unit_holder','special_unit_holder','lender','donor','donee'].indexOf(current_object.option.party_class) !== -1) {
                    result.push('Trust');
                }

                return result;
            }
        },
        methods: {
            reset_cache_data: function(option) {
                if (typeof option === 'undefined') {
                    option = {};
                }

                let current_object = this;

                let cache_data = {
                    // class: '',
                    type: 'Individual',
                    address_id: '',
                    // trust_id: '',

                    // Fields below for type = 'Individual'
                    title: '',
                    first_name: '',
                    middle_name: '',
                    last_name: '',
                    birthday: '',

                    // Fields below for type = 'Company'
                    name: '',
                    company_number: '',
                    business_number: '',

                    // Fields below for type = 'Trust'
                    trustee: [],

                    // Fields below for special classes
                    email:'',
                    phone:'',
                    fax:'',
                    director_name: '',
                    description: '',
                    unit_count: 1,
                    income_type: '',
                    redemption_type: '',
                    redemption_percentage: 0,
                    income_ld_proportion: 1,
                    income_proportion: 1,
                    capital_ld_proportion: 1,
                    capital_proportion: 1,

                    update_address: false,
                    store_for_future: false,
                };
                if (!option.init) {
                    current_object.cache_data = Object.assign(current_object.cache_data,cache_data);
                    cache_data = current_object.cache_data;
                }
                let data_set = current_object;
                if (option.data_set) {
                    data_set = option.data_set;
                }
                cache_data[data_set.form_root.module_name+'_id'] = '';

                data_set.current_party = {};
                if (current_object.option) {
                    if (['company_trustee','trustee'].indexOf(current_object.option.party_class) !== -1) {
                    // if (current_object.option.party_class === 'trustee') {
                        cache_data.type = 'Company';
                    }
                    // if (['appointor','beneficiary','beneficiary_b'].indexOf(current_object.option.party_class) !== -1) {
                    //     cache_data.type = 'Individual';
                    // }
                    // if (current_object.available_types.length === 1) {
                    //     cache_data.type = current_object.available_types[0];
                    // }
                    if (data_set.current_id) {
                        if (!data_set.form_root.item_map[data_set.form_root.module_name + '_party']) {
                            data_set.form_root.item_map[data_set.form_root.module_name + '_party'] = {};
                            data_set.form_root.item_list[data_set.form_root.module_name + '_party'] = [];
                        } else {
                            if (data_set.form_root.item_map[data_set.form_root.module_name + '_party'][data_set.current_id]) {
                                cache_data = Object.assign(cache_data, data_set.form_root.item_map[data_set.form_root.module_name + '_party'][data_set.current_id]);
                                if (cache_data.trustee.length) {
                                    for (let i=0;i<cache_data.trustee.length;i++) {
                                        if (typeof cache_data.trustee[i] !== 'string') {
                                            cache_data.trustee.splice(i, 1, cache_data.trustee[i].toString());
                                        }
                                    }
                                }
                                data_set.current_party = data_set.form_root.item_map[data_set.form_root.module_name + '_party'][data_set.current_id];
                            }
                        }
                    }
                }


                return cache_data;

            },

            fill_form_from_stored: function(event) {
                // console.log('fill_form_from_stored',event);
                let current_object = this;
                if (current_object.$root.item_map.stored_party && current_object.$root.item_map.stored_party[event.target.value]) {
                    let stored_party = current_object.$root.item_map.stored_party[event.target.value];
                    Object.keys(current_object.cache_data).forEach(function (field_name) {
                        if (['id','description'].indexOf(field_name) !== -1) {
                            return false;
                        }
                        if (typeof stored_party[field_name] !== 'undefined') {
                            current_object.cache_data[field_name] = stored_party[field_name];
                        }
                    });
                }
                if (current_object.cache_data['address_id'] === 0) {
                    current_object.cache_data['address_id'] = '';
                } else {
                    if (!current_object.form_root.item_map.address) {
                        current_object.form_root.item_map.address = {};
                        current_object.form_root.item_list.address = [];
                    }
                    if (!current_object.form_root.item_map.address[current_object.cache_data['address_id']] && current_object.$root.item_map.address[current_object.cache_data['address_id']]) {
                        current_object.form_root.item_map.address[current_object.cache_data['address_id']] = current_object.$root.item_map.address[current_object.cache_data['address_id']];
                        current_object.form_root.item_list.address.push(current_object.form_root.item_map.address[current_object.cache_data['address_id']]);
                    }
                }
                event.target.value = 0;
            },

            fill_form_from_cached: function(event) {
                let current_object = this;
                if (current_object.item_map[current_object.form_root.module_name + '_party'] && current_object.item_map[current_object.form_root.module_name + '_party'][event.target.value]) {
                    let cached_party = current_object.item_map[current_object.form_root.module_name + '_party'][event.target.value];
                    Object.keys(current_object.cache_data).forEach(function (field_name) {
                        if (['type','title','first_name','middle_name','last_name','name','company_number','business_number','director_name','address_id'].indexOf(field_name) !== -1) {
                            current_object.cache_data[field_name] = cached_party[field_name];
                        }
                    });
                }
                event.target.value = 0;
            },

            update_trustee: function(trust_party_id, party_class) {

                let current_object = this;

                current_object.current_trustee = '';
                if (!trust_party_id) {
                    return false;
                }
                if (typeof trust_party_id !== 'string') {
                    trust_party_id = trust_party_id.toString();
                }

                let trust_party = current_object.form_root.item_map[current_object.form_root.module_name + '_party'][trust_party_id];
                if (!trust_party) {
                    current_object.message_option.message = ['Invalide trust_party_id: ',trust_party_id];
                    current_object.message_option.message_type = 'error';
                    return false;
                }
                if (current_object.current_party.id) {
                    trust_party.parent_id = current_object.current_party.id;
                }

                if (current_object.cache_data['trustee'].indexOf(trust_party_id) === -1) {
                    current_object.cache_data['trustee'].push(trust_party_id);
                }
            },
            remove_from_list: function (item, list) {
                let index = list.indexOf(item);
                if (index > -1) {
                    list.splice(index,1);
                }
            },
            remove_sub_item: function (sub_item_id) {
                let current_object = this;
                current_object.deleted_trustee.push(sub_item_id);
                current_object.remove_from_list(sub_item_id,current_object.cache_data['trustee']);
            },

            save: function () {
                // TODO: if store_for_future checked, post stored data to server

                let current_object = this;
                let warning_message = [];
                let mandatory_fields = [];
                let formatted_name = '';
                let post_data = Object.assign({},current_object.cache_data);

                current_object.message_option.message = '';

                switch (post_data.type) {
                    case 'Individual':
                        formatted_name = post_data.last_name;
                        if (post_data.middle_name) {
                            formatted_name = post_data.middle_name + ' ' + formatted_name;
                        }
                        if (post_data.first_name) {
                            formatted_name = post_data.first_name + ' ' + formatted_name;
                        }
                        if (post_data.title) {
                            formatted_name = post_data.title + ' ' + formatted_name;
                        }

                        post_data.formatted_name = formatted_name;

                        if (post_data.birth_country !== 'AU') {
                            post_data.birth_state = 'Foreign';
                        }
                        mandatory_fields.push('first_name');
                        mandatory_fields.push('last_name');
                        if (current_object.party_class !== 'stored_party') {
                            mandatory_fields.push('address_id');
                        }

                        if (post_data.director_id) {
                            // Director ID validation, 15 digits start with 036 as Australian country code, last digit for check (not sure about the algorithm yet)
                            let stripped_director_id = post_data.director_id.replace(/[^0-9]+/g, '');
                            if (!stripped_director_id.match(/^036(\d){12}/)) {
                                warning_message.push('Invalid Director ID.');
                            }
                        }
                        break;
                    case 'Trust':
                        let i = 0;
                        let name_stack = [];
                        post_data.formatted_name = '';
                        post_data.address_id = 0;
                        post_data.business_number = '';
                        post_data.company_number = '';
                        // post_data.director_name = '';
                        while (post_data.trustee[i]) {
                            if (i > 0) {
                                if (i == post_data.trustee.length -1) {
                                    post_data.formatted_name += ' and ';
                                } else {
                                    post_data.formatted_name += ', ';
                                }
                            }
                            if (!post_data.address_id) {
                                post_data.address_id = current_object.form_root.item_map[current_object.form_root.module_name + '_party'][post_data.trustee[i]].address_id;
                            }
                            if (!post_data.business_number) {
                                post_data.business_number = current_object.form_root.item_map[current_object.form_root.module_name + '_party'][post_data.trustee[i]].business_number;
                            }
                            if (!post_data.company_number) {
                                post_data.company_number = current_object.form_root.item_map[current_object.form_root.module_name + '_party'][post_data.trustee[i]].company_number;
                            }
                            // if (current_object.form_root.item_map[current_object.form_root.module_name + '_party'][post_data.trustee[i]].director_name) {
                            //     if (post_data.director_name) {
                            //         post_data.director_name += ',';
                            //     }
                            //     post_data.director_name += current_object.form_root.item_map[current_object.form_root.module_name + '_party'][post_data.trustee[i]].director_name;
                            // }

                            if (current_object.form_root.item_map[current_object.form_root.module_name + '_party'][post_data.trustee[i]].type === 'Company') {
                                post_data.formatted_name += current_object.form_root.item_map[current_object.form_root.module_name + '_party'][post_data.trustee[i]].name;
                            } else {
                                post_data.formatted_name += current_object.form_root.item_map[current_object.form_root.module_name + '_party'][post_data.trustee[i]].formatted_name;
                            }
                            i++;
                        }
                        post_data.formatted_name += ' as trustee';
                        if (i > 1) {
                            post_data.formatted_name += 's';
                        }
                        post_data.formatted_name += ' for ' + post_data.name;
                        if (i < 1) {
                            warning_message.push('Field "'+current_object.cache_data_label['trustee']+'" is required.');
                        }
                        break;
                    case 'Company':
                    default:
                        post_data.formatted_name = post_data.name;
                        if (post_data.business_number) {
                            post_data.formatted_name += ' (A.B.N. '+post_data.business_number + ')';
                        } else {
                            if (post_data.company_number) {
                                post_data.formatted_name += ' (A.C.N. '+post_data.company_number + ')';
                            } else {
                                warning_message.push('Company and other entities must provide A.B.N. and/or A.C.N. for identification.');
                            }
                        }
                        mandatory_fields.push('name');
                        if (current_object.party_class !== 'stored_party') {
                            mandatory_fields.push('address_id');
                        }

                        break;
                }
                switch (current_object.party_class) {
                    case 'special_unit_holder':
                        mandatory_fields.push('unit_count');
                        if (current_object.option.trust && current_object.option.trust.ng) {
                            post_data.income_type = 'Attributable Income';
                            post_data.redemption_type = 'Negative Gearing';
                            post_data.redemption_percentage = 0;
                        } else {
                            mandatory_fields.push('income_type','redemption_type');
                        }
                        break;
                    case 'unit_holder':
                        mandatory_fields.push('unit_count');
                        break;
                    case 'contact':
                        mandatory_fields.push('email');
                        mandatory_fields.push('phone');
                        break;
                }
                if (post_data.email) {
                    if (!post_data.email.toLowerCase()
                        .match(
                            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        )) {
                        warning_message.push('Invalid Email Address.');
                    }
                }
                if (post_data.tax_number) {
                    // Director ID validation, 15 digits start with 036 as Australian country code, last digit for check (not sure about the algorithm yet)
                    let stripped_tax_number = post_data.tax_number.replace(/[^0-9]+/g, '');
                    if (stripped_tax_number.length != 9 ) {
                        warning_message.push('Invalid Tax File Number.');
                    } else {
                        let digits = stripped_tax_number.split('');
                        let sum = (digits[0]*1)
                            + (digits[1]*4)
                            + (digits[2]*3)
                            + (digits[3]*7)
                            + (digits[4]*5)
                            + (digits[5]*8)
                            + (digits[6]*6)
                            + (digits[7]*9)
                            + (digits[8]*10);

                        if (sum % 11 != 0) {
                            warning_message.push('Invalid Tax File Number.');
                        }
                    }
                }
                // General Validation, e.g. mandatory field empty, number format wrong...
                mandatory_fields.forEach(function (field_name) {
                    if (!post_data[field_name]) {
                        warning_message.push('Field "'+current_object.cache_data_label[field_name]+'" is required.');
                    } else {
                        if(field_name === 'redemption_type' && post_data[field_name].indexOf('Percentage') > -1) {
                            // When "Redemption Type" is mandatory field and has the "Percentage" related types selected, Redemption Percentage is mandatory
                            if (!post_data['redemption_percentage'] || post_data['redemption_percentage'] == '0') {
                                // v-model will make number input value as string, '0' is not equivalent to empty
                                warning_message.push('Field "'+current_object.cache_data_label['redemption_percentage']+'" is required.');
                            }
                        }
                    }
                });


                if (warning_message.length > 0) {
                    current_object.message_option.message_type = 'error';
                    current_object.message_option.message = warning_message;
                    return false;
                } else {
                    current_object.message_option.message_type = 'success';
                    current_object.message_option.message = '';
                }

                current_object.current_party.class = current_object.party_class;
                if (!current_object.current_party.id) {
                    current_object.current_party = Object.assign(current_object.current_party,post_data);
                    let index_counter = 1;
                    while (current_object.form_root.item_map[current_object.form_root.module_name + '_party']['new_'+index_counter]) {
                        index_counter++;
                    }
                    current_object.current_party.id = 'new_'+index_counter;

                    // if (!current_object.form_root.item_map[current_object.form_root.module_name + '_party']) {
                    //     current_object.form_root.item_map[current_object.form_root.module_name + '_party'] = {};
                    // }
                    current_object.form_root.item_map[current_object.form_root.module_name + '_party'][current_object.current_party.id] = current_object.current_party;
                    // if (!current_object.form_root.item_list[current_object.form_root.module_name + '_party']) {
                    //     current_object.form_root.item_list[current_object.form_root.module_name + '_party'] = [];
                    // }
                    if (current_object.form_root.item_list[current_object.form_root.module_name + '_party'].indexOf(current_object.current_party) === -1) {
                        current_object.form_root.item_list[current_object.form_root.module_name + '_party'].push(current_object.current_party);
                    }
                    if (current_object.cache_data.trustee.length) {
                        let trust_list_index = current_object.form_root.item_list[current_object.form_root.module_name + '_party'].indexOf(current_object.form_root.item_map[current_object.form_root.module_name + '_party'][current_object.current_party.id]);
                        let min_trustee_list_index = trust_list_index;
                        current_object.cache_data.trustee.forEach(function (trustee_id) {
                            if (current_object.form_root.item_map[current_object.form_root.module_name + '_party'][trustee_id]) {
                                current_object.form_root.item_map[current_object.form_root.module_name + '_party'][trustee_id].parent_id = current_object.current_party.id;

                                let trustee_list_index = current_object.form_root.item_list[current_object.form_root.module_name + '_party'].indexOf(current_object.form_root.item_map[current_object.form_root.module_name + '_party'][trustee_id]);
                                if (trustee_list_index > -1 && trustee_list_index < min_trustee_list_index) {
                                    min_trustee_list_index = trustee_list_index;
                                }
                            }
                        });
                        // parent party object must come before all children, to make the parent_id convert properly
                        if (min_trustee_list_index < trust_list_index) {
                            current_object.form_root.item_list[current_object.form_root.module_name + '_party'].splice(trust_list_index,1);
                            current_object.form_root.item_list[current_object.form_root.module_name + '_party'].splice(min_trustee_list_index,0,current_object.form_root.item_map[current_object.form_root.module_name + '_party'][current_object.current_party.id]);
                        }
                    }
                } else {
                    current_object.current_party = Object.assign(current_object.current_party,post_data);
                }
                if (current_object.deleted_trustee.length) {
                    current_object.deleted_trustee.forEach(function (sub_item_id) {
                        let form_root = current_object.form_root;
                        console.log(sub_item_id, typeof sub_item_id)
                        if (typeof sub_item_id !== 'string') {
                            sub_item_id = sub_item_id.toString();
                        }
                        if (sub_item_id.match(/^new_/)) {
                            current_object.remove_from_list(form_root.item_map[form_root.module_name + '_party'][sub_item_id], form_root.item_list[form_root.module_name + '_party']);
                            delete current_object.item_map[form_root.module_name + '_party'][sub_item_id];
                        } else {
                            form_root.item_map[form_root.module_name + '_party'][sub_item_id].deleted = true;
                        }
                    });

                }
                // $('html, body').stop().animate({
                //     scrollTop:$(current_object.$el).offset().top - 200
                // }, 550);
                if ($(current_object.$el.parentNode).hasClass('scrolltop_container')) {
                    let scrolltop_wrapper = $(current_object.$el.parentNode).closest('.scrolltop_wrapper');
                    if (scrolltop_wrapper.length > 0) {
                        $('html, body').scrollTop(scrolltop_wrapper.offset().top);
                    }
                }
console.log('allen debug update contact submit',current_object.current_party.id,current_object.party_class,current_object.form_root.item_map,current_object.form_root.item_list);
                // this.$emit('update:new_contact',this.cache_data.id);
                current_object.$emit('submit',current_object.current_party.id,current_object.party_class);
            },
            cancel: function () {
                let current_object = this;

                // Erase error message if applicable
                current_object.message_option.message_type = '';
                current_object.message_option.message = '';

console.log('allen debug update_trust_party cancel',current_object.current_party.id,current_object.party_class,current_object.form_root.item_map,current_object.form_root.item_list);
                // this.$emit('update:new_contact','');
                // $('html, body').stop().animate({
                //     scrollTop:$(current_object.$el).offset().top - 200
                // }, 550);
                if ($(current_object.$el.parentNode).hasClass('scrolltop_container')) {
                    let scrolltop_wrapper = $(current_object.$el.parentNode).closest('.scrolltop_wrapper');
                    if (scrolltop_wrapper.length > 0) {
                        $('html, body').scrollTop(scrolltop_wrapper.offset().top);
                    }
                }
                // current_object.$emit('submit',current_object.current_party.id?current_object.current_party.id:'',current_object.party_class);
                current_object.$emit('submit','',current_object.party_class);
            }
        },
        watch: {
            current_id: function () {
                let current_object = this;

                current_object.reset_cache_data();

                console.log('UpdateTrustParty current_object.current_id change',current_object,current_object.current_id,$(current_object.$el.parentNode).offset().top,current_object.$el.parentNode.offsetTop);
                if (current_object.current_id && $(current_object.$el.parentNode).hasClass('scrolltop_container')) {
                    console.log('UpdateTrustParty scrollTop triggered',$(current_object.$el.parentNode).offset().top, current_object,current_object.$el);
                    // $('html, body').stop().animate({
                    //     scrollTop:$(current_object.$el.parentNode).offset().top - 20
                    // }, 550);
                    // $('html, body').scrollTop($(current_object.$el.parentNode).offset().top - 20);

                    $('html, body').stop().animate({
                        scrollTop:$(current_object.$el.parentNode).offset().top - 20
                    }, 550,'swing',function () {
                        $('html, body').scrollTop($(current_object.$el.parentNode).offset().top - 20);
                        console.log('UpdateTrustParty scrollTop 2',$(current_object.$el.parentNode).offset().top,$('html').scrollTop(),$('body').scrollTop(),$('#app').scrollTop());
                    });

                    console.log('UpdateTrustParty scrollTop 1',$(current_object.$el.parentNode).offset().top,$('html').scrollTop(),$('body').scrollTop(),$('#app').scrollTop())
                }

                current_object.message_option.message = '';
                current_object.message_option.message_type = '';
            }
        }
    }
</script>